module.exports = __webpack_public_path__ + "static/img/logo.a92e8c05.png";